<header class="sp-mb-16 feedback-header">
  <h3 class="sp-mb-8 fs-32px text-color-gray-13 feedback-title">{{ (feedbackType === "positive" ? "your_feedback_matters" : "help_us_improve") | localize }}</h3>
  <p class="sp-m-0">{{ (feedbackType === "positive" ? "sharing_helps_improve_future_suggestions" : "tell_us_so_we_can_improve_future_suggestions") | localize }}</p>
</header>

<div class="sp-mb-16 feedback-input">
  <textarea [(ngModel)]="userFeedback" [uiFocus]="true" ui-input maxlength="500" data-test-id="suggestion-feedback-text-area"></textarea>
</div>

<footer class="sp-pt-20">
  <pi-feedback-modal-action-bar (feedbackSubmit)="handleSubmitFeedback()" (feedbackClose)="handleClose()"></pi-feedback-modal-action-bar>
</footer>
